export default __webpack_public_path__ + "static/media/share_sms_keyboard_icon.7d655bd2.png";